import { useCallback, useRef, useState } from "react";

const clone = (value) => JSON.parse(JSON.stringify(value));
export const ruleKey = () => crypto.randomUUID();
export const prepareRules = (rules) => rules.map((rule, i) => ({ ...rule, _key: rule._key || rule.id || ruleKey(), order: i + 1 }));

export const useTemplateDraft = (initial) => {
  const [state, setState] = useState(() => ({ form: clone(initial), original: clone(initial), past: [], future: [] }));
  const current = useRef(state);
  current.current = state;
  const setForm = useCallback((value) => setState((prev) => {
    const next = typeof value === "function" ? value(prev.form) : value;
    if (JSON.stringify(next) === JSON.stringify(prev.form)) return prev;
    return { ...prev, form: next, past: [...prev.past.slice(-39), prev.form], future: [] };
  }), []);
  const startDraft = useCallback((value) => {
    const snapshot = { ...clone(value), rules: prepareRules(value.rules || []) };
    setState({ form: snapshot, original: clone(snapshot), past: [], future: [] });
  }, []);
  const undo = () => setState((prev) => !prev.past.length ? prev : ({
    ...prev, form: prev.past[prev.past.length - 1], past: prev.past.slice(0, -1), future: [prev.form, ...prev.future],
  }));
  const redo = () => setState((prev) => !prev.future.length ? prev : ({
    ...prev, form: prev.future[0], past: [...prev.past, prev.form], future: prev.future.slice(1),
  }));
  const reset = () => setForm(clone(current.current.original));
  return { form: state.form, setForm, startDraft, undo, redo, reset,
    canUndo: !!state.past.length, canRedo: !!state.future.length,
    dirty: JSON.stringify(state.form) !== JSON.stringify(state.original) };
};